import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CustomerAvatar = ({ className, customerName }) => (
  <React.Fragment>
    { customerName != null && <div className={ `${ className !== null ? className : 'desktop-username' } col-md-10` }>
      <div className="row m-0 tooltip">
        <span className="text-left"><FontAwesomeIcon icon="user-circle" size="lg" /></span>
        <h3 className="col-10 text-left pr-0">{ customerName }</h3>
        <span className="tooltiptext">{ customerName }</span>
      </div>
    </div> }
  </React.Fragment>
);

CustomerAvatar.propTypes = {
  className: PropTypes.string,
  customerName: PropTypes.string
};

CustomerAvatar.defaultProps = {
  className: null,
  customerName: null
};

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig
    },
  } = state;

  return {
    customerName: onlineConfig != null ? onlineConfig.customerName : null
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerAvatar);
